import $ from 'jquery';
import detectIt from 'detect-it';


window.onload = () => {
  $('.js-modal').each((index, item) => {
    $(item).on('click', openModal);
  });
};

const openModal = e => {
  e.preventDefault();

  const target = e.currentTarget;
  const data = $(target).data().modal;
  const modal = $(target).siblings(`.${data}`);
  const iframe = $(modal).find('iframe');

  if (typeof window.wp_cf_consent !== 'undefined' && window.wp_cf_consent.performance === false) {
    iframe.hide();

    let lang = $('html')[0].lang, messages = {
        en: 'In order to see our 3D models, you have to accept performance cookies <a href="/">here</a>',
        de: 'Um unsere 3D Modelle sehen zu können, müssen Sie <a href="/">hier</a> Performance Cookies akzeptieren',
        fr: 'Pour voir nos modèles 3D, vous devez accepter les cookies de performance <a href="/">ici</a>',
        it: 'Per poter vedere i nostri modelli 3D, è necessario accettare i cookie delle prestazioni <a href="/">qui</a>.'
      },

      html = ' <div class="section wp_cf_js"> <div class="section__in"> <h2 class="title">Cookies notice</h2> <div class="wrapper-form">' + messages[lang] + '</div> <div class="wrapper-message" style="display: none;"> <div class="message-success"></div> <div class="close-button"> <span class="button__icon"> <div class="btn btn_light btn_sm"><span>Close</span></div> </span> </div> </div> </div> </div> ';

    let section = $(modal).find('.modal__in .wp_cf_js');
    section.remove();

    $(modal).find('.modal__in').append(html);
    $(modal).find('.modal__in .wp_cf_js a').on('click', (event) => {
      event.preventDefault();

      window.webpardChangeCookieSettingsDialog();
      $(modal).trigger('click');
    });

    $(modal).addClass('is-open');
    $(modal).on('click', closeModal);
    $('body').addClass('is-offscroll');
      
    return false;
  }

  $(modal).find('.modal__in .wp_cf_js').remove();
  iframe.show();

  if (detectIt.deviceType === 'touchOnly') {
    window.open('https://sketchfab.com/models/' + $(target).data().model, '_blank');
  } else {

    $(modal).addClass('is-open');
    $(modal).on('click', closeModal);
    $('body').addClass('is-offscroll');
    iframe.attr('src', iframe.attr('data-src'));
  }
};

const closeModal = e => {
  const target = e.target;
  const modal = $(target).closest('.modal');

  if (
    $(target).closest('.modal__close').hasClass('modal__close') ||
      $(target).hasClass('modal')
  ) {
    $(modal).removeClass('is-open');
    $('body').removeClass('is-offscroll');
    $(modal).off('click', closeModal);
  }
};
